import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { User } from "../lib/types";

type AuthState = {
  token: string | null;
  user: User | null;
  setSession: (token: string, user: User) => void;
  clear: () => void;
};

function createAuthStore(name: string) {
  return create<AuthState>()(
    persist(
      (set) => ({
        token: null,
        user: null,
        setSession: (token, user) => set({ token, user }),
        clear: () => set({ token: null, user: null })
      }),
      { name }
    )
  );
}

export const useCustomerAuthStore = createAuthStore("revlane-auth-customer");
export const useSellerAuthStore = createAuthStore("revlane-auth-seller");
export const useAdminAuthStore = createAuthStore("revlane-auth-admin");

export const useAuthStore = useCustomerAuthStore;

